import styles from "./guest-selection-buttons.module.less";
import RadioButtons from "components/forms/radio-buttons/radio-buttons";
import { isArray } from "@parksandresorts/core";
import { AnimateSharedLayout } from "framer-motion";
import RadioLabel from "./radio-label/radio-label";

const renderFilterButtons = (props) => {
  if (!isArray(props.guests)) {
    return null;
  }

  const radioButtons = props.guests.map((guest, index) => {
    const numberOfSelected = guest[props.passesArrayVariable].length;
    const totalPasses = guest[props.totalPassesVariable];

    const radioLabel = (
      <RadioLabel
        key={index}
        index={index}
        totalPasses={totalPasses}
        numberOfSelected={numberOfSelected}
        isActive={props.activeGuestIndex === index}
        name={guest.name}
        color={guest.color}
      />
    );
    return {
      value: index,
      label: radioLabel,
      disabled: totalPasses === 0,
    };
  });

  return (
    <RadioButtons
      options={radioButtons}
      value={props.activeGuestIndex}
      name="GuestSelection"
      wrapperClassName={styles.radioWrapper}
      itemWrapperClassName={styles.itemWrapper}
      onChange={(name, value) => {
        props.onSelectActiveGuest(parseInt(value));
      }}
    />
  );
};

const GuestSelectionButtons = (props) => {
  return (
    <div className={styles.wrapper}>
      <AnimateSharedLayout>{renderFilterButtons(props)}</AnimateSharedLayout>
    </div>
  );
};
GuestSelectionButtons.propTypes = {};
GuestSelectionButtons.defaultProps = {};
export default GuestSelectionButtons;
